import { useLanguage } from '../../../contexts/LanguageContext';
import { translations } from '../../../mocks/translations';

export default function CompanyDetails() {
  const { language } = useLanguage();
  const t = translations[language].company;

  return (
    <div className="space-y-8">
      <div className="text-center mb-12">
        <h2 className="text-4xl font-bold text-gray-900 mb-4">{t.title}</h2>
        <p className="text-lg text-gray-600">{t.subtitle}</p>
      </div>

      {/* Company Image Banner */}
      <div className="relative h-56 lg:h-72 rounded-2xl overflow-hidden mb-8">
        <img 
          src="https://public.readdy.ai/ai/img_res/680b535243016a8a1149f9b71aef2b3e.jpg"
          alt="Corporate Headquarters"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-gray-900/60 to-transparent"></div>
        <div className="absolute bottom-6 left-6 lg:bottom-8 lg:left-8">
          <h3 className="text-white font-bold text-2xl lg:text-3xl mb-2">QIUTOMS ENERGY FZ-LLC</h3>
          <p className="text-white/80 text-sm lg:text-base">{t.subtitle}</p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div className="bg-white p-8 rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
          <div className="flex items-start gap-4">
            <div className="w-14 h-14 flex items-center justify-center bg-teal-100 rounded-xl flex-shrink-0">
              <i className="ri-building-4-line text-2xl text-teal-600"></i>
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-bold text-gray-900 mb-2">{t.legalType}</h3>
              <p className="text-base text-gray-700 leading-relaxed">
                {t.legalTypeValue}
              </p>
              <p className="text-sm text-gray-500 mt-2">
                {t.legalTypeDescription}
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white p-8 rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
          <div className="flex items-start gap-4">
            <div className="w-14 h-14 flex items-center justify-center bg-emerald-100 rounded-xl flex-shrink-0">
              <i className="ri-user-star-line text-2xl text-emerald-600"></i>
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-bold text-gray-900 mb-2">{t.licensee}</h3>
              <p className="text-base text-gray-700 leading-relaxed">
                QIUTOMS ENRGY FZ-LLC
              </p>
              <p className="text-sm text-gray-500 mt-2">
                {t.licenseeDescription}
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white p-8 rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
          <div className="flex items-start gap-4">
            <div className="w-14 h-14 flex items-center justify-center bg-teal-100 rounded-xl flex-shrink-0">
              <i className="ri-store-2-line text-2xl text-teal-600"></i>
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-bold text-gray-900 mb-2">{t.operatingName}</h3>
              <p className="text-base text-gray-700 leading-relaxed">
                QIUTOMS ENRGY FZ-LLC
              </p>
              <p className="text-sm text-gray-500 mt-2">
                {t.operatingNameDescription}
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white p-8 rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
          <div className="flex items-start gap-4">
            <div className="w-14 h-14 flex items-center justify-center bg-emerald-100 rounded-xl flex-shrink-0">
              <i className="ri-global-line text-2xl text-emerald-600"></i>
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-bold text-gray-900 mb-2">{t.jurisdiction}</h3>
              <p className="text-base text-gray-700 leading-relaxed">
                {t.jurisdictionValue}
              </p>
              <p className="text-sm text-gray-500 mt-2">
                {t.jurisdictionDescription}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-8 relative rounded-xl overflow-hidden">
        <img 
          src="https://readdy.ai/api/search-image?query=Professional%20business%20compliance%20and%20certification%20concept%2C%20official%20documents%20with%20golden%20seal%20and%20ribbon%2C%20corporate%20achievement%2C%20teal%20and%20gold%20color%20scheme%2C%20elegant%20professional%20style&width=1200&height=250&seq=company2&orientation=landscape"
          alt="Compliance"
          className="w-full h-48 lg:h-56 object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-teal-600/90 to-emerald-600/90"></div>
        <div className="absolute inset-0 p-8 flex items-center">
          <div>
            <div className="flex items-center gap-4 mb-4">
              <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-lg">
                <i className="ri-shield-star-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-white">{t.complianceTitle}</h3>
            </div>
            <p className="text-base text-teal-50 leading-relaxed max-w-3xl">
              {t.complianceDescription}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
